<template>
  <div class="f1-container">
    <!-- 视频背景 -->
    <video class="video-bg" autoplay loop muted playsinline poster="https://static.htd.cn/mobileapp/html/skwebsite/banner1.webp">
      <source src="https://static.htd.cn/mobileapp/html/skwebsite/banner1.webm" type="video/webm">
    </video>

    <div class="div-banner">
      <div class="bn-left">
        <div class="flexrow" data-aos="fade-left" data-aos-duration="500" data-aos-offset="500">
          <p>
            <!-- <span class="txtBig txtColorWhite">汇通数科</span> -->
            <span class="txtBig">汇通数科</span>
          </p>
        </div>
        <div class="flexrow" data-aos="fade-left" data-aos-duration="600">
          <p class="txtMiddle">
            企业级的
          </p>
          <p class="txtBlue">AI应用服务商</p>
        </div>

        <div class="flexrow" style="margin-top: 30px; margin-bottom: 20px" data-aos="fade-left" data-aos-duration="700">
          <img src="@/assets/home/banner_check.svg" alt="" />
          <div class="txtSmall">
            海量智能体协作系统，实现复杂任务的智能分解与执行
          </div>
        </div>
        <div class="flexrow" style="margin-bottom: 20px" data-aos="fade-left" data-aos-duration="800">
          <img src="@/assets/home/banner_check.svg" alt="" />
          <div class="txtSmall">
            企业级数据服务 + 存算大模型一体机，全链路AI能力
          </div>
        </div>
        <div class="flexrow" style="margin-bottom: 20px" data-aos="fade-left" data-aos-duration="900">
          <img src="@/assets/home/banner_check.svg" alt="" />
          <div class="txtSmall">
            智能巡检机器人 + 零售服务机器人，赋能企业自动化升级
          </div>
        </div>
        <div class="flexrow" data-aos="fade-left" data-aos-duration="1000">
          <img src="@/assets/home/banner_check.svg" alt="" />
          <div class="txtSmall">
            全场景数字化解决方案，助力企业智能化转型
          </div>
        </div>
      </div>
      <div class="bottomTip">
        <img src="@/assets/home/mouse.png" alt="" />
        <div>向下划动 查看更多</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
.f1-container {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.video-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.div-banner {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 200;
  /* margin: 0 auto; */
  width: 1200px;
  height: 100vh;
  display: flex;
  align-items: center;

  .bn-left {
    display: flex;
    flex-direction: column;
    width: 500px;
    position: absolute;
    z-index: 111;
  }

  .txtBig {
    font-weight: bold;
    font-size: 52px;
    color: #1A1A1A;
    line-height: 42px;
    text-align: left;
  }

  .txtColorWhite {
    color: #ffffff;
  }

  .txtColorBlue {
    color: #1763ff;
  }

  .txtMiddle {
    font-weight: bold;
    font-size: 42px;
    color: #1A1A1A;
    line-height: 44px;
    text-align: left;
    margin-bottom: 0;
    margin-top: 15px;
  }

  .txtBlue {
    font-weight: bold;
    font-size: 42px;
    color: #1763FF;
    line-height: 44px;
    text-align: left;
    margin-bottom: 0;
    margin-top: 15px;
  }

  .txtSmall {
    font-size: 16px;
    color: #1A1A1A;
    line-height: 20px;
    text-align: left;
    margin-left: 6px;
    /* line-height: 20px; */
  }

  .flexrow {
    display: flex;

    img {
      width: 20px;
      height: 20px;
    }

    // flex-direction: row;
    // align-items: center;
  }

  .bannerimg {
    width: 1000px;
    height: 100%;
  }

  @keyframes bounce {

    0%,
    100% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(-20px);
    }
  }

  .bottomTip {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    height: 72px;
    display: flex;
    flex-direction: column;
    align-items: center;
    animation: bounce 1s infinite alternate;
    z-index: 11111;
  }

  .bottomTip img {
    width: 24px;
    height: 42px;
  }

  .bottomTip div {
    font-size: 12px;
    color: #ffffff;
    line-height: 20px;
    margin-top: 10px;
  }
}
</style>
